import classNames from "classnames";
import { Link } from "@components/core";
import { ALL_LETTERS } from "@utils/alphabeticalSorting";

function AlphabetSummary({ brandsByLetter }) {
  const letterHasBrands = (letter) => brandsByLetter[letter] && brandsByLetter[letter].length > 0;

  return (
    <div className="alphabet-summary">
      {ALL_LETTERS.map((letter) => (
        <Link
          key={`summary-${letter}`}
          href={`#${letter}`}
          className={classNames("link-dark d-inline-block brand-letter-link")}
          disabled={!letterHasBrands(letter)}
          noUnderline
        >
          {letter}
        </Link>
      ))}
    </div>
  );
}

export default AlphabetSummary;
